import { RegistrationStatus } from '@/features/dashboard/tours/types/RegistrationStatus.ts';
import { StatusTone } from '@/components/ui/statusTone.ts';

export const registrationDetailsTsUtils = {
  getLabel: (mode: RegistrationStatus): string => {
    return registrationModeConfig[mode].label;
  },

  getTextClass: (mode: RegistrationStatus): string => {
    return registrationModeConfig[mode].textClass;
  },

  getTone: (mode: RegistrationStatus): StatusTone => {
    return registrationModeConfig[mode].tone;
  },

  getConfig: (mode: RegistrationStatus): RegistrationModeConfig => {
    return registrationModeConfig[mode];
  },
};

type RegistrationModeConfig = {
  label: string;
  /** Stan zapisów to sam tekst w kolorze stanu — bez kropki i bez odznaki. */
  textClass: string;
  /**
   * Ten sam stan w nagłówku wyjazdu stoi już jako `StatusDot`, a ten maluje
   * się z tonu, nie z klasy tekstowej.
   */
  tone: StatusTone;
};

export const registrationModeConfig: Record<
  RegistrationStatus,
  RegistrationModeConfig
> = {
  [RegistrationStatus.OPEN]: {
    label: 'Otwarte',
    textClass: 'text-success-300 font-semibold',
    tone: 'success',
  },
  [RegistrationStatus.CLOSED]: {
    label: 'Zamknięte',
    textClass: 'text-neutral-500',
    tone: 'neutral',
  },
  [RegistrationStatus.PLANNED]: {
    label: 'Zaplanowane',
    textClass: 'text-accent-800',
    tone: 'warning',
  },
  [RegistrationStatus.NOT_SCHEDULED]: {
    label: 'Nieogłoszone',
    textClass: 'text-neutral-400',
    tone: 'neutral',
  },
  [RegistrationStatus.CANCELLED]: {
    label: 'Odwołane',
    textClass: 'text-error-300 font-semibold',
    tone: 'error',
  },
};
